import { ENV } from 'public/config'
import { getToken } from 'public/utils'
import { authChange, moduleUpgradeLog, attendanceOutFunc } from './websocket-func'

/**
 * 断开重连
 * 定时发送心跳包
 */
export default class websocket {
  constructor(ctx, token) {
    let conf = window.__ERPGLOABLECONFIG__ || {}
    this.ctx = ctx
    this.token = token
    this.lock = 0
    this.maxLock = 720 // 最大连接次数不能超过6小时 (6 * 60 * 60 * 1000) / (30 * 1000)
    this.heartMsg = 'websocket:ping'
    this.heartBeatTimeout = 2 * 60 * 1000 // 心跳时间2分钟
    this.heartBeatTimer = null
    this.reconnectTimeout = 30 * 1000 // 30秒延迟连接
    this.reconnectTimeTask = null
    this.timeout = (conf.webSocketTick || 60) * 1000
    this.setRemindMenus()
    this.createWebsocket()
  }

  createWebsocket () {
    this.gc()
    let host = ENV ? location.host : 'edge.uat.kye-erp.com'
    // let host = 'edge.uat.kye-erp.com'
    let url = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${host}/websocket/${getToken()}`
    const socket = new window.WebSocket(url)
    socket.onopen = () => {
      this.lock = 0
      this.pushMenuMsg()
      this.onheartbeat()
    }
    socket.onclose = () => {
      this.ctx.$bus.$emit('GLOBAL_WEBSOCKET_CLOSE')
      this.reconnect()
    }
    socket.onerror = () => {
      this.ctx.$bus.$emit('GLOBAL_WEBSOCKET_ERROR')
      this.reconnect()
    }
    socket.onmessage = e => {
      this.ctx.$bus.$emit('GLOBAL_WEBSOCKET', e.data)
      if (window.onGDPluginWebSocketMessage) {
        window.onGDPluginWebSocketMessage(e.data)
      }
      this.reset()
    }
    this.socket = socket
  }

  pushMenuMsg () {
    this.bindMenuMsg = this.handleMenuMsg.bind(this)
    this.ctx.$bus.$on('GLOBAL_WEBSOCKET', this.bindMenuMsg)
    this.reset()
  }

  handleMenuMsg (e) {
    if (e) {
      try {
        let data = JSON.parse(e)
        console.log('websocket:onmessage', data)
        if (data && this.remindMenus._keys.includes(data.moduleName)) {
          if (data.serviceCode === 'tic' && data.messageType) {
            let value = +(JSON.parse(data.messageType)[data.moduleName]) || 0
            this.ctx.$store.commit('SET_MENUS_REMIND', [{ key: this.remindMenus[data.moduleName], value }])
          } else if (data.serviceCode === 'ec-message' && data.content) {
            let value = data.content
            this.ctx.$store.commit('SET_MENUS_REMIND', [{ key: this.remindMenus[data.moduleName], value }])
          }
        } else if (['business', 'urm'].includes(data.moduleName)) {
          // 涉及到多端推送，需判断属于哪个系统，后端服务暂不能识别系统
          if (data.content && data.content.appId === 'gj_xdbvffz-hYOdFXSRlMg==') {
            authChange(data)
          }
        } else if (data.moduleName === 'system-center') {
          moduleUpgradeLog(data)
        } else if (data.moduleName === 'attendanceOut') {
          // 下班打卡退出
          attendanceOutFunc(data)
        }
      } catch (e) {
        console.log('websocket:onmessage', e)
      }
    }
  }

  onheartbeat() {
    clearInterval(this.heartBeatTimer)
    this.heartBeatTimer = setInterval(() => {
      this.ping()
    }, this.heartBeatTimeout)
  }

  ping() {
    this.socket.send(this.heartMsg)
  }

  setRemindMenus () {
    let arr = this.ctx.$store.state.lookUpOptions['auth_menu_remind'] || []
    let obj = arr.reduce((s, v) => {
      s[v.value] = v.label
      return s
    }, {})
    obj._keys = Object.keys(obj)
    this.remindMenus = obj
  }

  reset () {
    if (!ENV) {
      return
    }
    clearTimeout(this.timeoutTask)
    clearTimeout(this.serverTimeoutTask)
    this.timeoutTask = setTimeout(_ => {
      if (!this.socket) {
        return
      }
      this.ping()
      // send 后 socket 异常时，需要主动断开来触发重连机制
      // CONNECTING: 0, OPEN: 1, CLOSING: 2, CLOSED: 3
      this.serverTimeoutTask = setTimeout(_ => {
        if (this.socket && this.socket.readyState > 1) {
          this.socket.close()
        }
      }, 60000)
    }, this.timeout)
  }

  close () {
    this.socket && this.socket.close()
    this.ctx.$bus.$off('GLOBAL_WEBSOCKET', this.bindMenuMsg)
  }

  reconnect () {
    if (this.lock > this.maxLock || !ENV) {
      return
    }
    clearTimeout(this.reconnectTimeTask)
    this.reconnectTimeTask = setTimeout(_ => {
      this.createWebsocket()
      this.lock++
      console.log('websocket:reconnect')
    }, this.reconnectTimeout)
  }

  gc () {
    if (this.socket) {
      this.socket.onopen = null
      this.socket.onmessage = null
      this.socket.onclose = null
      this.socket.onerror = null
      this.socket = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/websocket.js